import template from './AttendantItemView.html';
import { AttendantItemController } from './AttendantItemController';
export const AttendantItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: AttendantItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        attendants: '<',
        teams: '<',
        ownerAgentSlots: '<',
        editingAgentSlots: '<',
        isAttendancePermissionEnabled: '<',
        application: '<',
        onDelete: '&',
        closeDropdownDelete: '&',
        closeDropdownEdit: '&',
        onCheckAttendant: '&',
        attendantPermission: '&',
        agentSlotsError: '&',
        editTeams: '&?',
        onSave: '&?',
    },
};
